import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Shared wrapper for every /auth screen. Mirrors the Claude Design export's
 * SetupLayout pattern: full-viewport background, fixed-width card pinned
 * from the top, consistent inner padding. Every consumer (today
 * platform-admin; future business/niche apps) renders auth screens through
 * this layout so width, top anchoring and inner padding stay consistent.
 */
export function AuthLayout({ children, centred = false }) {
    return (_jsx("div", { className: "min-h-screen bg-duvi-bg flex justify-center px-6 pt-[150px]", children: _jsx("div", { className: `w-full max-w-[480px] h-fit bg-duvi-surface border border-duvi-border rounded-[8px] p-8${centred ? " text-center" : ""}`, style: { boxShadow: "var(--shadow-card)" }, children: children }) }));
}
//# sourceMappingURL=AuthLayout.js.map